import { type JSX, Show } from "solid-js";
import { ArrowLeft } from "@fleet/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@vigia/shared";
import { useI18n } from "@/providers/i18n-provider";
import { msg } from "@lingui/core/macro";
import { useNavigate } from "@tanstack/solid-router";

interface PageSubHeaderProps {
  title: string;
  backTo?: string;
  icon?: (props: { class?: string }) => JSX.Element;
  rightElement?: JSX.Element;
  class?: string;
}

export function PageSubHeader(props: PageSubHeaderProps) {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <header
      class={cn("flex h-14 items-center gap-3 border-b border-border px-6 shrink-0", props.class)}
    >
      {props.backTo && (
        <Button
          variant="ghost"
          size="icon"
          class="h-8 w-8 shrink-0"
          onClick={() => void navigate({ to: props.backTo })}
          title={t(msg`Back`)}
        >
          <ArrowLeft class="h-4 w-4" />
        </Button>
      )}
      {props.icon && (
        <span class="shrink-0 text-primary">
          <props.icon class="h-5 w-5" />
        </span>
      )}
      {/*
        `page-subheader-title` es el chrome ESTÁTICO de la ruta y el ancla de la
        sonda de I4 (P23 / CC-60): debe pintarse con las peticiones del API aún
        en vuelo. Anclar la sonda a un encabezado enterrado en la pantalla da
        rojos falsos con la máquina cargada.
      */}
      <h1 data-testid="page-subheader-title" class="text-base font-semibold truncate">
        {props.title}
      </h1>
      <Show when={props.rightElement}>
        <div class="ml-auto flex items-center shrink-0">{props.rightElement}</div>
      </Show>
    </header>
  );
}
